import React, { useState } from "react";
import { PropertyInfra, PropertyInfraIndexed } from "../../../types/api.types";

import { Divider } from "common/components/listItems/Divider";
import { PropertyDistanceCard } from "./PropertyDistanceCard";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { AppraiserProperty } from "../../../types/appraiser.types";
import { SchoolDialog } from "./SchoolDialog";

interface DistancesSectionProps {
  name: string;
  infras: PropertyInfraIndexed[];
  property: AppraiserProperty;
}

/** The exam dialog is for the ranked gymnasium. A primary or basic school has no results to open. */
function isRankedGymnasium(infra: PropertyInfra) {
  if (infra.subtype !== "school") return false;
  if (infra.school_slot === "gymnasium") return true;
  if (infra.school_slot === "primary") return false;
  const kind = infra.meta?.["buss type"] ?? infra.meta?.buss_type;
  return kind === "Gimnazija";
}

export const DistancesSection: React.FC<DistancesSectionProps> = ({
  name,
  infras,
  property,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedInfra, setSelectedInfra] = useState<PropertyInfra | null>(
    null
  );

  const handleOpenModal = (infra: PropertyInfra) => {
    setSelectedInfra(infra);
    setOpenModal(true);
  };

  return (
    <div>
      <div
        style={{
          fontSize: "20px",
          marginBottom: "15px",
        }}
      >
        {name}
      </div>
      <div>
        {infras.map((infra) => {
          return (
            <div
              key={infra._id}
              style={{
                display: "flex",
                marginBottom: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: 1 }}>
                <PropertyDistanceCard
                  infra={infra}
                  infraNumber={infra.index + 1}
                />

                <Divider
                  style={{
                    marginTop: "10px",
                  }}
                />
              </div>
              {isRankedGymnasium(infra) && (
                <KeyboardArrowRightIcon
                  style={{ marginBottom: "10px", cursor: "pointer" }}
                  onClick={() => handleOpenModal(infra)}
                />
              )}
            </div>
          );
        })}
      </div>
      <SchoolDialog
        open={openModal}
        infra={selectedInfra}
        propertyId={property._id}
        onClose={() => setOpenModal(false)}
      />
    </div>
  );
};
